

























































































































































































































































import {
  Vue, Component, Prop, Watch,
} from 'vue-property-decorator';
import moment from 'moment';
import { COLLECTION_ORGANIZATIONS, COLLECTION_ROLES, COLLECTION_USERS } from '@/model/AppConstants';
import FirebaseUtil from '@/model/FirebaseUtil';
import PermUtil from '@/model/PermUtil';
import RoleType from '@/userManagement/RoleType';
import Member from '@/model/Member';
import StatusType from '@/model/typelist/StatusType';
import OrgAbout from './Organization/About.vue';
import PostComp from './Organization/PostView.vue';
import Settings from './Organization/Settings.vue';
import Followers from './Organization/Followers.vue';
import Members from './Organization/Members.vue';
import MemberModeration from './Organization/MemberModeration.vue';
import Group from './Organization/Group.vue';

@Component({
  components: {
    OrgAbout,
    PostComp,
    Settings,
    Followers,
    Members,
    MemberModeration,
    Group,
  },
})
export default class OrgComponent extends Vue {
  show = false;

  showComments = [];

  modDialog = false;

  memberDialog = false;

  selected = false;

  privatepost = [];

  dialog = false;

  tab = null;

  groupOrg = '';

  roleObj = {
    role: RoleType,
  } as any;

  searchKey = '';

  items = ['About', 'Posts', 'Followers', 'Members', 'Settings', 'Moderator', 'Group'];
  // eslint-disable-next-line
  parentObj(orgId: any) {
    const parentOrg = this.$store.state.approvedOrganizations.find((org: any) => org.id === orgId);
    this.$store.commit('setOrg', parentOrg);
    this.$router.push(`/organization/${orgId}`);
  }

  parentName(orgId: any) {
    return this.$store.state.approvedOrganizations.find((org: any) => org.id === orgId);
  }
  // mounted() {}
  // eslint-disable-next-line
  get roles() {
    return RoleType.memberRoles();
  }

  get org() {
    return this.$store.state.orgObj;
  }

  get viewPostTab() {
    if (this.viewModTab) {
      return true;
    }
    return this.org.followers.includes(this.currentUser.uid) || this.memberCheck();
  }

  get viewPrivatePostTab() {
    if (this.viewModTab) {
      return true;
    }
    return this.memberCheck();
  }

  memberCheck() {
    return !!this.org
      .members.find((m: any) => m.id === this.currentUser.uid && m.status.code === 'approved');
  }

  get viewModTab() {
    return (this.org.moderator.uid === this.currentUser.uid);
  }

  get viewGroupTab() {
    if (this.org.parent) {
      return false;
    }
    if (this.viewModTab) {
      return true;
    }
    return !!this.org.members.some(
      (m: any) => m.id === this.currentUser.uid && m.status.code === 'approved');
  }

  submitSearch(searchKey: any) {
    this.$store.dispatch('findModerator', searchKey);
  }

  get removeOrg() {
    const clone = { ...this.currentUser };
    const list = [] as any;
    clone.roles.forEach((role: any) => {
      list.push(FirebaseUtil.ObjectToRef(COLLECTION_ROLES, role.id));
    });
    clone.roles = list;
    const index = clone.organizations.findIndex((m: any) => m.id === this.currentUser.uid);
    clone.organizations.splice(index, 1);
    return clone;
  }
  // eslint-disable-next-line
  async leaveMember() {
    const clone = { ...this.org };
    clone.moderator = FirebaseUtil.ObjectToRef(COLLECTION_USERS, this.org.moderator.id);
    const index = this.org.members.findIndex((m: any) => m.id === this.currentUser.uid);
    clone.members.splice(index, 1);
    await this.$store.dispatch('updateCollection', {
      collection: COLLECTION_ORGANIZATIONS,
      doc: this.org.id,
      payload: clone,
    });
    this.$store.dispatch('updateCollection', {
      collection: COLLECTION_USERS,
      doc: this.currentUser.uid,
      payload: this.removeOrg,
    });
    this.dialog = false;
  }

  get moderator() {
    const mod = this.$store.state.moderators;
    return mod[0];
  }

  modChange() {
    this.modDialog = true;
  }

  close() {
    this.modDialog = false;
    this.formClear();
  }

  get parsedOrgObj() {
    const clone = { ...this.org };
    clone.moderator = FirebaseUtil.ObjectToRef(COLLECTION_USERS, this.org.moderator.id);
    const member = new Member();
    member.id = this.currentUser.uid;
    member.role = FirebaseUtil.ObjectToRef(COLLECTION_ROLES, this.roleObj.role.code);
    member.status = { ...StatusType.waitingForApproval };
    clone.members.push({ ...member });
    return clone;
  }

  // eslint-disable-next-line
  async addMember() {
    await this.$store.dispatch('updateCollection', {
      collection: COLLECTION_ORGANIZATIONS,
      doc: this.org.id,
      payload: this.parsedOrgObj,
    });
    this.formClear();
  }

  defaultOrganization = Object.freeze({
    Moderator: '',
    orgName: '',
    orgType: '',
  });

  organization = { ...{}, ...this.defaultOrganization };

  follow() {
    const clone = { ...this.org };
    clone.followers.push(this.currentUser.uid);
    clone.moderator = FirebaseUtil.ObjectToRef(COLLECTION_USERS, this.org.moderator.id);
    const list = [] as any;
    clone.members.forEach((m: any) => {
      const mem = new Member();
      mem.id = m.id;
      mem.status = m.status;
      mem.role = FirebaseUtil.ObjectToRef(COLLECTION_ROLES, m.role.roleType.code);
      list.push({ ...mem });
    });
    clone.members = list;
    this.$store.dispatch('updateCollection', {
      collection: COLLECTION_ORGANIZATIONS,
      doc: this.org.id,
      payload: clone,
    });
  }

  unfollow = () => {
    const clone = { ...this.org };
    clone.moderator = FirebaseUtil.ObjectToRef(COLLECTION_USERS, this.org.moderator.id);
    const index = clone.followers.findIndex((id: any) => id === this.currentUser.uid);
    clone.followers.splice(index, 1);
    this.$store.dispatch('updateCollection', {
      collection: COLLECTION_ORGANIZATIONS,
      doc: this.org.id,
      payload: clone,
    });
  };

  get followTitle() {
    return this.org.followers.includes(this.currentUser.uid) ? 'UnFollow' : 'Follow';
  }
  // eslint-disable-next-line
  get disableBtn() {
    return !!this.org.members.find((m: any) => m.id === this.currentUser.uid);
  }

  get memberTitle() {
    if (this.org.members.find((m: any) => m.id === this.currentUser.uid)) {
      return this.checkStatus();
    }
    return 'Member';
  }

  checkStatus() {
    if (this.org.members.find((m: any) => m.status.code === 'waitingForApproval')) {
      return 'Waiting For Approval';
    }
    if (this.org.members.find((m: any) => m.status.code === 'approved')) {
      return 'Approved';
    }
    return 'Need Change Status';
  }

  get orgPosts() {
    return this.$store.state.OrgPosts;
  }

  get currentUser() {
    return this.$store.state.freshCurrentUser;
  }

  formatTime = (time: any) => {
    const date = new Date(time.seconds * 1000);
    return moment(date).fromNow();
    // return `${date.getHours()}:${date.getMinutes()}`;
  };

  get parsedOrg() {
    const clone = { ...this.org };
    clone.moderator = FirebaseUtil.ObjectToRef(COLLECTION_USERS, this.moderator.uid);
    return clone;
  }

  UpdateMod() {
    this.$store.dispatch('updateCollection', {
      collection: COLLECTION_ORGANIZATIONS,
      doc: this.org.id,
      payload: { ...this.parsedOrg },
    });
    this.$router.push('/Organization');
    this.modDialog = false;
    this.formClear();
  }

  formClear() {
    this.searchKey = '';
    this.memberDialog = false;
    this.$store.commit('setModEmpty', []);
    this.selected = false;
  }
}
